import useDetectInstance from "@SonarCX/hooks/useDetectInstance";

const useDetectNihalife = () => {
  const { isMatched: isNihalife } = useDetectInstance({ name: "NIHALIFE" });

  return { isNihalife };
};

export default useDetectNihalife;
